import api from "../api"
import { saveAs } from 'file-saver'

export const ACTION_TYPES = {
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE',
    FETCH_DASHBOARD: 'FETCH_DASHBOARD',
    FETCH_OC_BY_STATUS: 'FETCH_OC_BY_STATUS',
    FETCH_EVIDENCE: 'FETCH_EVIDENCE',
    FETCH_REJECTED_INVOICE: 'FETCH_REJECTED_INVOICE',
    FETCH_INSTALLATION_ORDER_DETAIL: 'FETCH_INSTALLATION_ORDER_DETAIL',
    FETCH_TECHNICIANS: 'FETCH_TECHNICIANS',
    FILTER_TECHNICIANS: 'FILTER_TECHNICIANS',
    SAVE_TECHNICIANS: 'SAVE_TECHNICIANS',
    UPDATE_TECHNICIANS: 'UPDATE_TECHNICIANS',
    DELETE_TECHNICIANS: 'DELETE_TECHNICIANS',
    FETCH_PHONE_TYPES: 'FETCH_PHONE_TYPES',
    FETCH_VIATIC_DOCUMENTS: 'FETCH_VIATIC_DOCUMENTS',
    FETCH_INVOICE_SERVICE_DOCUMENTS: 'FETCH_INVOICE_SERVICE_DOCUMENTS',
    FETCH_EXCEL_SERVICES: 'FETCH_EXCEL_SERVICES',
    FETCH_TECHNICIANS_ORDERS: 'FETCH_TECHNICIANS_ORDERS',
    FETCH_TECHNICIANS_BY_ORDER: 'FETCH_TECHNICIANS_BY_ORDER'
}

export const fetch_Dashboard = (lang, token, supplierId, onError, onSuccess) => dispatch => {
    api.Telematics().fetchDashboard(lang, token, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_DASHBOARD,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_oc_by_status = (lang, token, branchOfficeId, stage, onError, onSuccess) => dispatch => {
    api.Telematics().fetchOCByStatus(lang, token, branchOfficeId, stage)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_OC_BY_STATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_filter_by_date = (lang, token, startDate, endDate, status, branchOfficeId, filter, onError, onSuccess) => dispatch => {
    api.Telematics().fetchFilterByDate(lang, token, startDate, endDate, status, branchOfficeId, filter)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_OC_BY_STATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_filter_by_text = (lang, token, startDate, endDate, stage, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Telematics().fetchFilterByText(lang, token, startDate, endDate, stage, branchOfficeId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_OC_BY_STATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_Installation_Order_Detail = (lang, token, branchOfficeID, installationOrderId, onError, onSuccess) => dispatch => {
    api.Telematics().fetchInstallationOrderDetail(lang, token, branchOfficeID, installationOrderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INSTALLATION_ORDER_DETAIL,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Technicians = (lang, token, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Telematics().fetchTechnicians(lang, token, branchOfficeId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_TECHNICIANS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const filter_Technicians = (lang, token, branchOfficeId, filterTechnician, onError, onSuccess) => dispatch => {
    api.Telematics().filterTechnicians(lang, token, branchOfficeId, filterTechnician)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FILTER_TECHNICIANS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const save_Technicians = (lang, token, saveTechnician, onError, onSuccess) => dispatch => {
    api.Telematics().saveTechnicians(lang, token, saveTechnician)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.SAVE_TECHNICIANS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const update_Technicians = (lang, token, technicianId, updateTechnician, onError, onSuccess) => dispatch => {
    api.Telematics().updateTechnicians(lang, token, technicianId, updateTechnician)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.UPDATE_TECHNICIANS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Technicians = (lang, token, deleteTechnician, onError, onSuccess) => dispatch => {
    api.Telematics().deleteTechnicians(lang, token, deleteTechnician)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.DELETE_TECHNICIANS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Phone_Types = (lang, token, onError, onSuccess) => dispatch => {
    api.Telematics().fetchPhoneTypes(lang, token)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_PHONE_TYPES,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const Download_Order_Detail_PDF = (lang, token, branchOfficeID, installationOrderId, onError) => dispatch => {
    api.Telematics().DownloadOrderDetailPDF(lang, token, branchOfficeID, installationOrderId)
        .then(response => {
            const data = "data:application/pdf;base64," + response.data.fileBase64
            saveAs(data, response.data.fileName)
        })
        .catch((err) => {
            onError(err)
        })
}

export const fetch_Viatic_Documents = (lang, token, instalationId, isViatic, onError, onSuccess) => dispatch => {
    api.Telematics().fetchViaticDocuments(lang, token, instalationId, isViatic)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_VIATIC_DOCUMENTS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const update_Invoice_Order = (lang, token, files, onError, onSuccessSave) => dispatch => {
    api.Telematics().UploadInvoiceOrder(lang, token, files)
        .then(response => {
            onSuccessSave(response.data)
        })
        .catch(err => onError(err))
}

export const download_Viatic_Document = (lang, token, documentId, isService, onError) => dispatch => {
    api.Telematics().DownloadDocument(lang, token, documentId, isService)
        .then(response => {
            const data = "data:application/pdf;base64," + response.data.fileBase64
            saveAs(data, response.data.fileName)
        })
        .catch((err) => {
            onError(err)
        })
}

export const delete_Viatic_Document = (lang, token, instalationId, documentId, onError, onSuccessDelete) => dispatch => {
    api.Telematics().deleteViaticDocument(lang, token, instalationId, documentId)
        .then(response => {
            onSuccessDelete()
        })
        .catch(err => onError(err))
}

export const fetch_Evicence_Service_By_Id = (lang, token, serviceId, onError, onSuccess) => dispatch => {
    api.Telematics().fetchServiceEvidenceById(lang, token, serviceId, onSuccess)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EVIDENCE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const update_Service_Evidence = (lang, token, serviceId, file, onError, onSuccessSave) => dispatch => {
    api.Telematics().UploadServiceEvidence(lang, token, serviceId, file)
        .then(response => {
            onSuccessSave(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Invoice_Errors = (lang, token, orderNumber, onError, onSuccess) => dispatch => {
    api.Telematics().fetchInvoiceErrors(lang, token, orderNumber, onSuccess)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_REJECTED_INVOICE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Invoice_Service_Documents = (lang, token, serviceNumber, onError, onSuccess) => dispatch => {
    api.Telematics().fetchInvoiceServiceDocuments(lang, token, serviceNumber, onSuccess)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INVOICE_SERVICE_DOCUMENTS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Service_Document = (lang, token, instalationId, documentId, onError, onSuccessDelete) => dispatch => {
    api.Telematics().deleteServiceDocument(lang, token, instalationId, documentId)
        .then(response => {
            onSuccessDelete()
        })
        .catch(err => onError(err))
}

export const update_Invoice_Service = (lang, token, files, onError, onSuccessSave) => dispatch => {
    api.Telematics().UploadInvoiceService(lang, token, files)
        .then(response => {
            onSuccessSave(response.data)
        })
        .catch(err => onError(err))
}

export const accept_Installation_order = (lang, token, orderId, acceptOrder, onError, onSuccessSave) => dispatch => {
    api.Telematics().acceptOrDeclineInstallationOrder(lang, token, orderId, acceptOrder)
        .then(response => {
            onSuccessSave(response.data)
        })
        .catch(err => onError(err))
}

export const delete_Evidence = (lang, token, serviceId, evidenceId, onError, onSuccessDelete) => dispatch => {
    api.Telematics().deleteEvidence(lang, token, serviceId, evidenceId)
        .then(response => {
            onSuccessDelete(response.data)
        })
        .catch(err => onError(err))
}

export const UploadWorkCompleted = (lang, token, data, serviceId , onError, onSuccess) => dispatch => {
    api.Telematics().UploadWorkCompleted(lang, token, data, serviceId)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const Upload_Excel_Invoice_To_Services = (lang, token, file , onError, onSuccess) => dispatch => {
    api.Telematics().UploadExcelInvoiceToServices(lang, token, file)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const assing_Technician = (lang, token, orderId, installerId, onError, onSuccess) => dispatch => {
    api.Telematics().asignTechnician(lang, token, orderId, installerId)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Excel_Documents = (lang, token, instalationId, isViatic, onError, onSuccess) => dispatch => {
    api.Telematics().fetchViaticDocuments(lang, token, instalationId, isViatic)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EXCEL_SERVICES,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Technicians_Orders = (lang, token, onError, onSuccess) => dispatch => {
    api.Telematics().fetchTechniciansOrders(lang, token)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_TECHNICIANS_ORDERS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Technicians_By_Order = (lang, token, orderNumber, onError, onSuccess) => dispatch => {
    api.Telematics().fetchTechniciansByOrder(lang, token, orderNumber)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_TECHNICIANS_BY_ORDER,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Assigned_Technician = (lang, token, installerId, orderInstallationId, onError, onSuccessDelete) => dispatch => {
    api.Telematics().deleteAssignedTechnician(lang, token, installerId, orderInstallationId)
        .then(response => {
            onSuccessDelete(response.data)
        })
        .catch(err => onError(err))
}